<ng-container *ngFor="let section of sections">
    <kw-preview-section kwSectionAttributes [attr.section-id]="section.sectionId" [section]="section" [attr.renderer-type]="section.rendererType"></kw-preview-section>
</ng-container>
